"use client";
import Image from "next/image";
import React, {useCallback, useEffect, useState} from "react";
import throttle from "lodash.throttle";
import PlayIcon from "@heroicons/react/16/solid/PlayIcon";
import ChevronLeftIcon from "@heroicons/react/16/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/16/solid/ChevronRightIcon";

export default function ProductGallery(props) {

    const {product, handleSetCurMedia, curMedia, handleGalleryToggle} = props;


    //const [curImage, setCurImage] = useState(product.image || null);
    const [zoomEvent, setZoomEvent] = useState(false);
    const [videoContent, setVideoContent] = useState(false);

    /*    useEffect(() => {
            if(zoomEvent)
                console.log(zoomEvent);
        }, [zoomEvent]);*/

    useEffect(() => {
        if (product.media_gallery_entries && product.media_gallery_entries.length > 0) {
            if (handleSetCurMedia) {
                handleSetCurMedia({
                    type: product.media_gallery_entries[0].media_type === 'external-video' ? 'video' : 'image',
                    file: product.media_gallery_entries[0].file,
                    video: product.media_gallery_entries[0].media_type === 'external-video' ? product.media_gallery_entries[0].extension_attributes.video_content?.video_url : null,
                });
            }
        }
    }, []);

    const handleZoom = useCallback(throttle((e) => {
        if (e)
            setZoomEvent(e);
        else
            setZoomEvent(false);
    }, 16), []);

    const handleSelectMedia = (entry) => {

        if (handleSetCurMedia) {
            handleSetCurMedia(entry);
        }

    }

    const handleNextMedia = () => {
        let curIndex = product.media_gallery_entries.findIndex(entry => entry.file === curMedia.file);
        if (curIndex < product.media_gallery_entries.length - 1) {
            handleSetCurMedia(product.media_gallery_entries[curIndex + 1]);
        } else {
            handleSetCurMedia(product.media_gallery_entries[0]);
        }
    }

    const handlePrevMedia = () => {
        let curIndex = product.media_gallery_entries.findIndex(entry => entry.file === curMedia.file);
        if (curIndex > 0) {
            handleSetCurMedia(product.media_gallery_entries[curIndex - 1]);
        } else {
            handleSetCurMedia(product.media_gallery_entries[product.media_gallery_entries.length - 1]);
        }
    }


    return <div className={'product-gallery flex flex-col lg:flex-row lg:pr-2'}>

        <div
            className={'hidden lg:flex w-[12%] lg:w-[45px] space-y-2  absolute  lg:flex-col lg:relative z-10 top-3 left-3  lg:top-auto lg:left-auto'}>

            {product.media_gallery_entries && <>
                {product.media_gallery_entries.map((entry, index) =>
                    <div key={'product_media_' + index}
                         className={`relative cursor-pointer border rounded after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full flex items-center ${entry.file === curMedia?.file ? 'border-[#e7bb43]' : 'border-white '}`}
                         onMouseOver={(e) => handleSelectMedia(entry)}>

                        <Image src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + entry.file}
                               alt={product.name}
                               priority={false}
                               width={40}
                               height={40}
                               sizes="40px"
                               className="w-full object-cover object-center aspect-square rounded"/>
                        {entry.media_type === 'external-video' && <div
                            className={'absolute rounded top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center '}>
                            <PlayIcon className={'w-8 h-8 fill-[#e7bb43]'}/>
                        </div>}
                    </div>)}
            </>
            }

        </div>

        <div className={'relative grow flex items-center w-full '}>
            {curMedia && curMedia?.file && <>
                <div
                    className={'w-full relative  after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full cursor-pointer'}
                    onMouseEnter={(e) => handleZoom(e)}
                    onMouseOver={(e) => handleZoom(e)}
                    onMouseMove={(e) => handleZoom(e)}
                    onMouseLeave={() => handleZoom(false)}
                    onClick={handleGalleryToggle}
                >


                    <Image src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + curMedia.file}
                           alt={product.name}
                           width={512}
                           height={512}
                           sizes="(max-width: 768px) 100vw,(max-width: 512px) 50vw,33vw"
                           priority={true}
                           className="w-full object-contain object-center"

                    />
                    {curMedia.type === 'video' && <div
                        className={'absolute rounded top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center '}>
                        <PlayIcon className={'w-20 h-20 fill-[#e7bb43]'}/>
                    </div>}


                </div>

                <div className={`gallery-controls  absolute  flex lg:hidden items-center justify-between h-1/2 w-full overflow-hidden`}>
                    <div className={`absolute -left-5`} onClick={handlePrevMedia}>
                        <ChevronLeftIcon className={'w-28 h-28 fill-[#e7bb43]'}/>
                    </div>
                    <div className={`absolute -right-5`} onClick={handleNextMedia}>
                        <ChevronRightIcon className={'w-28 h-28 fill-[#e7bb43]'}/>
                    </div>
                </div>
                {curMedia && curMedia.type==='image' && zoomEvent && <div
                    className={'absolute top-0 right-0 w-[130%] h-[130%] border translate-x-full shadow-lg hidden md:block'}>
                    <div
                        className={'relative w-full h-full overflow-hidden  after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full'}>
                        <Image src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + curMedia.file}
                               alt={product.name}
                               sizes="(max-width: 768px) 100vw,(max-width: 512px) 50vw,33vw"
                               width={640}
                               height={640}
                               className="w-full h-full"
                               priority={false}
                               style={{
                                   transform: `translate(-${zoomEvent.nativeEvent.offsetX * 1.8}px, -${zoomEvent.nativeEvent.offsetY * 1.8}px) scale(2.5)`,
                                   transformOrigin: 'top left'
                               }}

                        />
                    </div>
                </div>}
            </>}
        </div>


        <div className={`block lg:hidden`}>
            {/* dots for each entries */}
            <div className={'flex space-x-2 items-center justify-center mt-2'}>
                {product.media_gallery_entries && <>
                    {product.media_gallery_entries.map((entry, index) =>
                        <div key={'product_media_dot_' + index}
                             className={`cursor-pointer rounded-full w-3 h-3 ${entry.file === curMedia?.file ? 'bg-[#e7bb43]' : 'bg-gray-400 '}`}
                             onClick={() => handleSelectMedia(entry)}/>)}
                </>
                }
            </div>
        </div>

        {/*{videoContent && videoContent?.video_url && <VideoPopup video={videoContent} setVideoContent={setVideoContent} />}*/}
    </div>;


}